import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

import { getBlog, updateBlog } from '../../routes/UserAction';
import { domain, timeFormat } from '../../data/dummyData';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

export default function Blog() {
    const { user } = useSelector((state) => state.user || {});
    const dispatch = useDispatch();

    const search = useLocation().search;
    const id = new URLSearchParams(search).get("id");

    const [pageData, setPageData] = useState(null);
    const [isMine, setIsMine] = useState(false);

    const fetchPage = () => {
        dispatch(getBlog(id))
            .then(response => {
                setPageData(response.payload.data);
                if (user?.id === response.payload.data?.user?.id) {
                    setIsMine(true);
                }
            })
            .catch((error) => console.log(error));
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSendMessage();
            // alert(`Enter key pressed!`);
        }
    };

    const [textField, setTextField] = useState("");
    const handleTextFieldChange = (e) => {
        setTextField(e.target.value);
    }

    const handleSendMessage = () => {

        if (textField !== '') {

            dispatch(updateBlog({
                msg: textField,
                app_source: 1, // emylab web
                row_id: id,
                chat_id: pageData?.chat?.id,
                action: 1, // comment
            }))
            .then(response =>{
                fetchPage();
                setTextField('')
            })
            .catch((error) => {
                console.log(error)
            })
        }
        
    }

    const handleLike = () => {

        dispatch(updateBlog({
            msg: '',
            app_source: 1,
            row_id: id,
            action: 2,
        }))
        .then(response =>{
            fetchPage();
            setTextField('')
        })
        
    }

    const handleView = () => {

        dispatch(updateBlog({
            msg: '',
            app_source: 1,
            row_id: id,
            action: 3,
        }))
        .then(response =>{
            fetchPage();
            setTextField('')
        })
        
    }

    // const handlePhoneChange = (e) => {
    //     // Remove all non-digit characters
    //     let value = e.target.value.replace(/\D/g, '');
    
    //     // Add the '233' prefix if it's not there
    //     if (!value.startsWith('233')) {
    //       value = '233' + value;
    //     }
    
    //     // Trim the value to ensure it only has a total of 12 digits (including the '233' prefix)
    //     if (value.length > 12) {
    //       value = value.substring(0, 12);
    //     }
    
    //     setPhone(value);
    // };

    useEffect(() => {
        fetchPage();

        const viewTimeout = setTimeout(() => {
            handleView();
        }, 3000); // Delay in milliseconds (3000ms = 3 seconds)
    
        return () => clearTimeout(viewTimeout); // Cleanup in case component unmounts early
    }, [id]);

    return (
        <>
            <Header page={'blog'} />

            {/* <!-- About Start --> */}
            <div className="container-fluid about pt-5" style={{zIndex: 1}}>
                <div className="container pt-5">
                    <div className="row g-5">
                        <div className="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
                            <div className="about-content h-100">
                                <h4 className="" style={{color: 'gold'}}>{pageData?.name? pageData.name: ''}</h4>
                                {/* <h1 className="display-4 text-white mb-4">{pageData?.about? pageData.about: ''}</h1> */}
                                <hr/>
                                <p className="mb-4 text-white">{pageData?.about? pageData.about: ''}</p>
                                
                                <div className="small text-white"><span className="fa fa-calendar text-white me-2"></span> {pageData?.created_at? timeFormat(pageData?.created_at): ''}</div>

                                <div className="d-flex justify-content-start gap-4 mt-3 mb-4">
                                    <span className='text-white'><i className="bi bi-heart-fill text-white" onClick={() => handleLike()}></i> {pageData?.likes? pageData.likes.length: 0} Likes</span>
                                    <span className='text-white'><i className="bi bi-eye-fill text-white"></i> {pageData?.views? pageData.views.length: 0} Views</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 wow fadeInUp" data-wow-delay="0.2s">
                            <div className="about-img h-100">
                                <div className="about-img-inner d-flex h-100">
                                    <img src={pageData?.image? domain+pageData.image: "./assets/img/emy.png"} className="img-fluid w-100" style={{objectFit: 'contain'}} alt={pageData?.uuid? pageData.uuid :''}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- About End --> */}

            <div className="container-fluid py-2 bg-light">
                <div className="container py-2">
                    {pageData ? (
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="card shadow-sm border-0 mb-4">
                                    
                                    <div className="card-body">
                                        

                                        <div>
                                            <h5 className="mb-3">Comments</h5>
                                            {pageData.chat?.chats?.length ? <div className="mb-4">
                                                    {pageData.chat.chats.map((comment, index) => (
                                                        <div key={index} className="border-bottom pb-2 mb-2">
                                                            <strong>{comment.user?.first_name? comment.user?.first_name: 'Anonymous'}:</strong>
                                                            <p className="mb-0">{comment.msg}</p>
                                                        </div>
                                                    ))}
                                                </div>: <p className="text-muted">No comments yet. Be the first!</p>}

                                            <form>
                                                <div className="mb-3">
                                                    <textarea
                                                        className="form-control"
                                                        rows="3"
                                                        value={textField} 
                                                        onKeyPress={handleKeyPress} 
                                                        onChange={handleTextFieldChange}
                                                        placeholder="Write your comment here..."
                                                    />
                                                </div>
                                                <button onClick={() => handleSendMessage()} type="button" className="btn btn-primary">
                                                    Submit Comment
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status" />
                            <p className="mt-3">Loading blog post...</p>
                        </div>
                    )}
                </div>
            </div>

            <Footer />
        </>
    );
}
